import React from "react";

import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

function Users() {

  const users = [

    {
      id: 1,
      name: "Rahul",
      role: "Customer",
      mobile: "9876543210",
      status: "Active"
    },

    {
      id: 2,
      name: "Suresh",
      role: "Supervisor",
      mobile: "9876500000",
      status: "Active"
    },

    {
      id: 3,
      name: "Mahesh",
      role: "Staff",
      mobile: "9876511111",
      status: "Inactive"
    }

  ];

  return (

    <div>

      <Navbar />

      <Sidebar />

      <div
        style={{
          marginLeft: "240px",
          padding: "20px",
          background: "#f5f7fa",
          minHeight: "100vh"
        }}
      >

        <h1
          style={{
            marginBottom: "20px",
            color: "#2e7d32"
          }}
        >
          Users Management
        </h1>


        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "20px"
          }}
        >

          {users.map((user) => (

            <div
              key={user.id}
              style={cardStyle}
            >

              <h2>{user.name}</h2>

              <p>
                <strong>Role:</strong> {user.role}
              </p>

              <p>
                <strong>Mobile:</strong> {user.mobile}
              </p>

              <p>
                <strong>Status:</strong> {user.status}
              </p>

            </div>

          ))}

        </div>

      </div>

    </div>

  );
}


const cardStyle = {

  background: "white",

  padding: "20px",

  borderRadius: "12px",

  boxShadow: "0 4px 10px rgba(0,0,0,0.1)"

};


export default Users;